var _a;
import { isModuleConfig, Module } from "../constants";
var systemColorMap = (_a = {},
    _a[isModuleConfig.Product] = {
        primary: "#EB6A2C",
        secondary: "#1B1D21",
        disabled: "#C3CCD6",
        hint: "rgba(0,0,0,0.37)",
        purple: "#34325D",
        grey: "#DEE4EB",
        darkGrey: "#6A7682",
        black: "#31394d",
        white: "#ffffff",
        mainColor: "#FFFFFF",
        //'#000000'
        backgroundColor: "#F4F7FA",
        //
        success: "#52C41A",
        error: "#F5222D",
        warning: "#FC7B09",
        info: "#6B7D6A",
        textSecondary: "rgba(0, 0, 0, 0.6)",
        icon: "#A8B5C2",
        lightGrey: "#8593A3",
        borderColor: "#3697FF",
        blue: "#0052ff",
        lightThemeColor: '#FFF7F0',
        tertiaryTextColor: '#A8B5C2'
    },
    _a[isModuleConfig.Bajaj] = {
        primary: "#0052FF",
        secondary: "#EB6A2C",
        disabled: "#C3CCD6",
        hint: "rgba(0,0,0,0.37)",
        purple: "#34325D",
        grey: "#DEE4EB",
        darkGrey: "#6A7682",
        black: "#31394d",
        white: "#ffffff",
        mainColor: "#FFFFFF",
        //'#000000'
        backgroundColor: "#F4F7FA",
        //
        success: "#52C41A",
        error: "#F5222D",
        warning: "#FC7B09",
        info: "#6B7D6A",
        textSecondary: "rgba(0, 0, 0, 0.6)",
        icon: "#A8B5C2",
        lightGrey: "#8593A3",
        borderColor: "#3697FF",
        blue: '',
        lightThemeColor: '#EEF6FF',
        tertiaryTextColor: '#7AB2FF'
    },
    _a);
export var systemColor = systemColorMap[Module];
